
import * as types from '../mutation-types'
import axios from 'axios'
// import moment from 'moment'

//
export const state = {

  atendimentos: [],

  filtro: {
      status: 'Todos',
      de: new Date(),
      ate: new Date()
   }

}

//
export const actions = {

  async getAtendimentos({commit}, filtro){

    try {

      commit(types.SET_FILTRO,  filtro  )

      const { data } = await axios.post('/api/atendimentos-buscar-json', filtro)

      commit(types.SET_ATENDIMENTOS, { atendimentos: data})

    } catch (e) {


    }

  }

}

//
export const mutations = {

  [types.SET_ATENDIMENTOS](state, { atendimentos }){
      state.atendimentos = atendimentos
  },

  [types.SET_FILTRO] (state,  filtro ){
      state.filtro = filtro
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/atendimento.js